import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

const { useFind: useUserPaths, useGet: useUserPath } = getCRUDHooks({
  entityName: 'userPaths',
  find: ({ userId }) => clientApi.getOCClient().helpers.user.users.id(userId).paths.find(),
  get: ({ userId, pathId }) =>
    clientApi.getOCClient().helpers.user.users.id(userId).paths.get(pathId),
});

export { useUserPaths, useUserPath };
